import src from "IMAGE";
export default { src, width: 774, height: 876, blurWidth: 0, blurHeight: 0};
